import { useQuery } from 'react-query';

import env from 'environments';
import { getPrintCreditsBalance } from 'modules/api/digitalServices/mailOnDemand';

/**
 * Shared react-query key for the member's ledger credit balance
 * (GET /v1/credits/balance?creditType=print). Every surface that shows the
 * member's credits reads through this key, and every flow that changes the
 * balance (MOD pay/cancel, credit purchase) invalidates it so the header
 * updates without a reload.
 */
export const PRINT_CREDITS_BALANCE_QUERY_KEY = 'printCreditsBalance';

export const isLedgerCreditsDisplayEnabled = () => Boolean(env.LEDGER_CREDITS_DISPLAY);

export const usePrintCreditsBalance = (options = {}) =>
  useQuery(PRINT_CREDITS_BALANCE_QUERY_KEY, getPrintCreditsBalance, options);
